import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimesheetEntityEditorDataState = atom({
  key: "myTimesheetEntityEditorDataState",
  default: {
    name: "",
    description: "",
    validFrom: new Date(),
    validTo: "",
  },
  effects_UNSTABLE: [ocPersistAtom],
});

export default myTimesheetEntityEditorDataState;
